import { render, staticRenderFns } from "./mycommunity.vue?vue&type=template&id=6e5f0aac&"
import script from "./mycommunity.js?vue&type=script&lang=js&"
export * from "./mycommunity.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports